'use strict';

angular.module('login', ['ngAnimate', 'msUtility', 'msCore', 'msAssessment', 'msOnboarding', 'smoothScroll', 'translations', 'angularModalService', 'msTracker', 'msSleep']).run(['$rootScope', '$state', '$document', '$location', 'smoothScroll', 'wellnessSvc', 'eventTrackingSvc', 'NotifyingSvc', 'ModalService', '$log', function ($rootScope, $state, $document, $location, smoothScroll, wellnessSvc, eventTrackingSvc, NotifyingSvc, ModalService, $log) {
  $rootScope.$state = $state;
  $rootScope.updateRootToken = function () {};
  $rootScope.isMobileWebView = false;
  $rootScope.mobilePlatform = null;
  $rootScope.telehealthTriggered = false;
  $rootScope.webViewPostMessages = {
    login: {
      path: 'login',
      parameters: {}
    },
    home: {
      path: 'home',
      parameters: {}
    },
    assessmentSkip: {
      path: 'home',
      isSkip: true,
      parameters: {}
    },
    telehealth: {
      path: 'TELEHEALTH_GETHELP',
      parameters: {}
    },
    agreements: {
      path: 'agreements',
      parameters: {}
    }
  };

  // Send postMessage to mobile app webview
  $rootScope.sendWebViewPostMessage = function (postMessageKey) {
    var postMessagePayload = $rootScope.webViewPostMessages[postMessageKey] ? $rootScope.webViewPostMessages[postMessageKey] : null;

    // If path home AND telehealthTriggered
    // replace payload with telehealth
    if (postMessagePayload && postMessagePayload.path === 'home' && $rootScope.telehealthTriggered === true) {
      postMessagePayload = $rootScope.webViewPostMessages.telehealth;
    }

    if ($rootScope.isMobileWebView && postMessagePayload) {
      // iOS
      try {
        window.webkit.messageHandlers.appInterface.postMessage(postMessagePayload, window.location.origin);
      } catch (error) {
        $log.debug('iOS postMessage error: ', error);
      }
      // Android
      try {
        window.appInterface.postMessage(JSON.stringify(postMessagePayload));
      } catch (error) {
        $log.debug('Android postMessage error: ', error);
      }
    }
  };

  $rootScope.$on('$stateChangeStart', function () {
    smoothScroll($('body')[0], {
      duration: 300
    });
  });

  activate();

  /////////

  function activate() {
    eventTrackingSvc.init();
    // send pageviews to google analytics
    eventTrackingSvc.registerEventListeners();
    // set up the assessments to have login copy & redirection
    wellnessSvc.translatePrefix = 'login';

    _setIsMobileWebView();

    NotifyingSvc.subscribe(NotifyingSvc.EVENTS.OPEN_MODAL, function (event, data) {
      ModalService.showModal({
        appendElement: angular.element($document[0].getElementById('modalTarget')),
        templateUrl: data.templateUrl || 'vnext/templates/generic-modal.html',
        controller: data.controller || 'GenericModalCtrl',
        controllerAs: data.controllerAs || '$ctrl',
        inputs: data.inputs,
        scope: data.scope,
        locationChangeSuccess: false
      }).then(function (modal) {
        modal.close.then(function (result) {
          if (angular.isFunction(data.closeCallback)) {
            data.closeCallback(result);
          }
        });
      });
    });
  }

  function _setIsMobileWebView() {
    var locationSearch = $location.search();
    if (!locationSearch) {
      return;
    }
    if (locationSearch.isMobileWebView) {
      $rootScope.isMobileWebView = true;
    }
    if (locationSearch.mobilePlatform) {
      // Set mobile platform
      $rootScope.mobilePlatform = locationSearch.mobilePlatform === 'android' ? 'android' : 'ios';
    }
  }
}]).constant('context', 'login');